import React from 'react';
import { Link } from 'react-router-dom';
import '../pages/404Page.css';

const NotFound = () => {
    return (
        <div className="not-found">
            <div className="overlay">
                <h1>Ruh Roh. </h1>
                <p className="ErrorOops">The Dimension you are looking for does not exist...yet</p>
                <h2 className="returnHomeButton"><Link to="/">
                    Return Home
                </Link>
                </h2>
            </div>
        </div>
    );
};

export default NotFound;
